import React from "react";
import {
  Filter,
  Create,
  AutocompleteInput,
  TextInput,
  LongTextInput,
  SaveButton,
  List,
  Datagrid,
  TextField,
  Pagination,
  ReferenceField,
  DateField,
  Button,
  Link,
  Toolbar,
  Edit,
  FunctionField,
  SimpleForm,
  EditButton,
  ReferenceInput,
  DateInput
} from "react-admin";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import RevokeBlacklistButton from "./revokeBlackListButton";
import { isNil } from "ramda";
import moment from "moment";

const ListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const BlackListTitle = object => (
  <span>
    {" Edit Blacklist entry "}{" "}
    {object.record.client
      ? `for "${object.record.client.client_first_name} ${object.record.client.client_last_name}"`
      : ""}
  </span>
);

const BlackListCreateTitle = record => <span>Create Blacklist entry</span>;

const BlackListsListFilter = props => (
  <Filter {...props}>
    <TextInput label="Client First Name" source="first_name" alwaysOn />
    <TextInput label="Client Last Name" source="last_name" alwaysOn />
    <TextInput label="Client Email" source="client_email" alwaysOn />
  </Filter>
);

const rowStyle = (record, index) => ({
  backgroundColor: !isNil(record.date_end) ? "#cccccc" : ""
});

export const BlackListsList = props => {
  return (
    <List
      {...props}
      title="BlackLists"
      resource="black_lists"
      pagination={<ListPagination />}
      filters={<BlackListsListFilter />}
      bulkActionButtons={false}
      sort={{ field: "date", order: "ASC" }}
      key={Date.now()}
    >
      <Datagrid rowStyle={rowStyle}>
        <TextField label="Client Id" source="client_id" />
        <ReferenceField
          label="First Name"
          source="client_id"
          reference="clients"
          linkType={false}
        >
          <TextField label="First Name" source="client_first_name" />
        </ReferenceField>
        <ReferenceField
          label="Last Name"
          source="client_id"
          reference="clients"
          linkType={false}
        >
          <TextField label="Last Name" source="client_last_name" />
        </ReferenceField>
        <TextField label="Reason" source="reason" />
        <DateField label="Start Date" source="date" />
        <DateField label="End Date" source="date_end" />
        <EditBlackListButton />
        <RevokeBlacklistButton />
      </Datagrid>
    </List>
  );
};

const EditBlackListButton = ({ record = {} }) => {
  return (
    <EditButton
      to={{
        pathname: `/black_lists/${record.id}`
      }}
      record={record}
      label="Edit"
    />
  );
};

const BlackListsToolbar = props => (
  <Toolbar {...props}>
    <SaveButton redirect={`/black_lists`} />
    <Button
      component={Link}
      to={{
        pathname: `/black_lists`
      }}
      label="Back to black list"
    >
      <ArrowBackIcon />
    </Button>
  </Toolbar>
);

const validateForm = values => {
  const errors = {};
  if (!values.date) {
    errors.date = ["Date is required"];
  }
  if (values.date && values.date_end) {
    if (moment(values.date).isAfter(moment(values.date_end))) {
      errors.date_end = ["End date must be later than date"];
    }
  }
  if (!values.client_id) {
    errors.client_id = ["Client is required"];
  }
  if (!values.reason) {
    errors.reason = ["Reason is required"];
  } 
  if (values.reason && values.reason.length > 255){
    errors.reason = [ "The text cannot be more than 255 characters" ];
  }    
  return errors;
};

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const BlackListsEdit = props => (
  <Edit title={<BlackListTitle />} {...props}>
    <SimpleForm
      toolbar={<BlackListsToolbar props={{ ...props }} />}
      validate={validateForm}
    >
      <DateInput label="Date" source="date"  locales="es-Es" options={{ timeZone: 'UTC' }}
          format={Fecha} />
      <DateInput label="Date End" source="date_end"  locales="es-Es" options={{ timeZone: 'UTC' }}
          format={Fecha} />
      <ReferenceField
        label="Client"
        source="client_id"
        reference="clients"
        linkType={false}
      >
        <FunctionField
          label="Client"
          render={client => {
            return `${client.client_first_name} ${client.client_last_name}`;
          }}
        />
      </ReferenceField>
      <LongTextInput source="reason" label="Reason" />
    </SimpleForm>
  </Edit>
);

export const BlackListsCreate = props => (
  <Create title={<BlackListCreateTitle />} {...props}>
    <SimpleForm validate={validateForm}>
      <DateInput label="Date" source="date"  locales="es-Es" options={{ timeZone: 'UTC' }} />
      <ReferenceInput
        label="Client"
        source="client_id"
        reference="clients"
        sort={{ field: "client_first_name", order: "ASC" }}
        perPage={500}
      >
        <AutocompleteInput
          optionText={client =>
            `${client.client_first_name} ${client.client_last_name}`
          }
        />
      </ReferenceInput>
      <LongTextInput source="reason" label="Reason" />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/blackLists.js